import { Fancybox } from "@fancyapps/ui";
import { BasePattern } from "@patternslib/patternslib/src/core/basepattern";
import Parser from "@patternslib/patternslib/src/core/parser";
import registry from "@patternslib/patternslib/src/core/registry";
import $ from "jquery";

export const parser = new Parser("ledprofessional");

class Pattern extends BasePattern {
    static name = "ledprofessional";
    static trigger = ".pat-ledprofessional";
    static parser = parser;

    pagepeel_expand(e) {
        var largeAd = $("#portal-pagepeel .largeAd"), lW = largeAd.width() + "px", lH = largeAd.height() + "px";
        $("#portal-pagepeel .smallAd").hide();
        largeAd.show();
        $("#portal-pagepeel").stop().animate({
            width: lW,
            height: lH
        }, 500);
    }

    pagepeel_minimize(e) {
        var smallAd = $("#portal-pagepeel .smallAd"), sW = smallAd.width() + "px", sH = smallAd.height() + "px";
        $("#portal-pagepeel").stop().animate({
            width: sW,
            height: sH
        }, 200, function () {
            $("#portal-pagepeel .smallAd").show();
            $("#portal-pagepeel .largeAd").hide();
        });
    }

    init_fancybox() {
        // related images
        Fancybox.bind("[data-fancybox], figure > a[href]", {
            // Your custom options
        });
    }

    async init() {
        let pagepeel = document.getElementById("portal-pagepeel");
        pagepeel.addEventListener("mouseover", this.pagepeel_expand);
        pagepeel.addEventListener("mouseout", this.pagepeel_minimize);
        this.init_fancybox();
    }
};


// Register Pattern class in the global pattern registry and make it usable there.
registry.register(Pattern);

// Export Pattern as default export.
// You can import it as ``import AnyName from "./ledprofessional";``
export default Pattern;
// Export BasePattern as named export.
// You can import it as ``import { Pattern } from "./ledprofessional";``
export { Pattern };
